import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})

export class AppComponent implements OnInit {

  title = 'BAV A. Ziselsberger GmbH Transporte & Netzservice';

  constructor() {}

  ngOnInit(): void {
  }

}
